export default {
  SESS_STORAGE_CUSTOMER_INFO_KEY: 'LENDFLOW_CUSTOMER_INFO_FORM_DATA',
  SESS_STORAGE_APPLICATION_KEY: 'LENDFLOW_APPLICATION',
  SESS_STORAGE_RELATIONSHIP_KEY: 'LENDFLOW_RELATIONSHIP',
};
